import React, { useState, useMemo } from 'react'
import styles from './index.scss'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import DpEmpty from '@/libs/components/DpUiComponents/DpEmpty'
import classnames from 'classnames'
import { SearchBar } from 'antd-mobile'
import { RightOutline } from 'antd-mobile-icons'
import request from '@/libs/functions/request'

interface IDPickerSearchProps {
  value?: string | string[]
  onChange?: Function
  title?: string
  disabled?: boolean
  placeholder?: string
  customStyles?: React.CSSProperties
  style?: React.CSSProperties
  config?: {
    url: string
    method?: 
    | 'OPTIONS'
    | 'GET'
    | 'HEAD'
    | 'POST'
    | 'PUT'
    | 'DELETE'
    | 'TRACE'
    | 'CONNECT'
    | undefined
    params?: Record<string, any>
  }
}
export function fetchApi({
    params,
    url,
    method
  }: {
    params?: any,
    url?: string,
    method?: any
  }) {
  return request({
    uri: url,
    params,
    method: method || 'GET',
    options: { isShowMessage: false, resolveData: true, hasLoading: false },
  })
}

const DpPickerSearch = (props: IDPickerSearchProps) => {
  const [visible, updateVisible] = useState(false)
  const [inputValue, updateInputValue] = useState<string | null>()
  const [dataSource, updateDataSource] = useState<any>([])

  async function fetchMoreData() {
    if (dataSource?.length > 0) {
      updateVisible?.(true)
      return
    }
    if (!props?.config?.url) {
      updateDataSource([])
      updateVisible?.(true)
    }
    const res: any = await fetchApi?.({
      params: props?.config?.params,
      url: props?.config?.url,
      method: props?.config?.method
    })
    updateDataSource(res?.code === -1 ? [] : (res?.list || []))
    updateVisible?.(true)
  }
  
  const showDataSource = useMemo(() => {
    if (!inputValue) return (dataSource || [])
    let data = (dataSource || [])?.filter((node: { label: string, value: string }) => node?.label?.includes(inputValue) || node?.value?.includes(inputValue))
    return data || []
  }, [inputValue, dataSource])

  const valueDesc = useMemo(() => {
    return props?.value && (typeof props?.value === 'string' ? props?.value?.split?.(',') : props?.value )
      ?.map((_item: string) => (dataSource || [])?.find((item: { label: string, value: string }) => item.value === _item)?.label)
      ?.join('、')
  }, [props?.value, dataSource])

  return (
    <div className={styles['dp-picker']} style={{...props?.customStyles, ...props?.style }}>
      <div
        onClick={() => {
          if (!props?.disabled) {
            fetchMoreData?.()
            updateInputValue?.('')
          }
        }}
        className={styles['dp-picker-desc']}
      >
        <div
          className={
            classnames([styles['dp-picker-desc-body'], { [styles['dp-picker-desc-body--disabled']]: props?.disabled } ])
          }
        >
          {valueDesc || (<span className={styles['dp-picker-placeholder']}>{props?.placeholder || '请选择'}</span>)}
        </div>
        {!props?.disabled && <RightOutline className={styles['dp-picker-arrows']} />}
      </div>
      {visible && (
        <DpBusinessPopup
          visible={visible}
          {...props}
          title={lang['请选择']}
          onClose={() => {
            updateVisible(!visible)
          }}
          onConfirm={() => {
            updateVisible(!visible)
          }}
          containerStyles={{ padding: '8px 10px 10px', background: 'var(--page-bg-color, #F5F6F8)' }}
          headerStyle={{
            borderBottomWidth: 0,
            color: 'var(--text-color, #202020)',
            background: 'var(--page-bg-color, #F5F6F8)'
          }}
          titleStyle={{
            color: 'var(--text-color, #202020)',
            textAlign: 'center',
          }}
          bodyStyle={{
            paddingBottom: 0,
            ...props?.customStyles,
            background: 'var(--page-bg-color, #F5F6F8)'
          }}
          popupBodyStyles={{
            background: 'var(--page-bg-color, #F5F6F8)',
            maxHeight: '100vh',
          }}
          popupProps={{
            getContainer: () => document.body
          }}
        >
          <div className={styles['dp-picker-container']}>
            <SearchBar
              showCancelButton
              placeholder={`${lang['请输入']}${props?.title || ''}`}
              className={styles['dp-picker-input']}
              style={{ '--border-radius': '18px' }}
              onChange={(e) => updateInputValue(e)}
              onClear={() => updateInputValue('')}
            />
            {
              showDataSource?.length ?
                <div className={styles['dp-picker-body']}>
                  <div className={styles['dp-picker-select']}>
                    {(showDataSource || []).map((item: { value: string, label: string }) => {
                      return (
                        <div key={item?.value} className={styles['dp-picker-select--item']} onClick={() => {
                          props?.onChange?.(item?.value, item)
                          updateVisible(!visible)
                        }}>
                          <div className={styles['dp-picker-select--item-name']}>{item?.label}</div>
                          <div className={styles['dp-picker-select--item-code']}>{item?.value}</div>
                        </div>
                      )
                    })}
                  </div>
                </div>
                : <DpEmpty emptyTips={'未找到可选数据'} />
            }
            
          </div>
        </DpBusinessPopup>
      )}
    </div>
  )
}

export default DpPickerSearch
